import './contacts.css'
function Contacts(para){
  const textData = para["textData"];
  return (
    <div id = 'contacts'>

      <div>{textData["contact1"]}</div>
      <div>{textData["contact_phone"]}</div>

      <div>{textData["contact2"]}</div>
      <div>{textData["contact_email"]}</div>

    </div>
  );
}
export default Contacts;